import { MoreHoriz } from "@material-ui/icons";
import { Checkbox } from "antd";
import React from "react";
import { COLORS } from "../pages/theme";

export default function GroupedUnreconciledCardExpandedItem({
    idx,
    isOurs,
    item,
    selected,
    onSelect,
    showTransactionModal,
}) {
    return (
        <div
            style={{
                // height: 88,
                padding: 16,
                display: "flex",
                border: "1px solid #E5E5E5",
                borderRadius: 4,
                fontSize: 16,
            }}
        >
            <div
                style={{
                    marginRight: 20,
                }}
            >
                <Checkbox
                    checked={selected === item.id}
                    onChange={() => onSelect(idx, isOurs, item.id)}
                />
            </div>
            <div
                style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                            title={
                                item.type == "C"
                                    ? "Credit"
                                    : item.type == "D"
                                    ? "Debit"
                                    : "N/A"
                            }
                            className={
                                item.type === "D"
                                    ? "debit-circle"
                                    : item.type == "C"
                                    ? "credit-circle"
                                    : "na-circle"
                            }
                            style={{
                                height: 34,
                                width: 34,
                                borderRadius: 18,
                                marginRight: 12,
                            }}
                        >
                            {item.type}
                        </div>
                        <div>{item.txn_date}</div>
                    </div>
                    <div>{item.transaction_id}</div>
                    <div style={{ display: "flex", color: COLORS.primary }}>
                        {item.amount}
                        <MoreHoriz
                            style={{ marginLeft: 20, color: COLORS.black }}
                            onClick={() => {
                                showTransactionModal(item.id)
                            }}
                        />
                    </div>
                </div>
                <div
                    style={{
                        fontSize: 12,
                        marginTop: 5,
                        color: COLORS.secondary,
                        // width: "50%",
                        // whiteSpace: "nowrap",
                        // overflow: "hidden",
                        // textOverflow: "ellipsis",
                    }}
                    title={item.description}
                >
                    {item.description}
                </div>
            </div>
        </div>
    );
}
